import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	DESKTOP_SM_BP,
	COLOR_WHITE,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 60px 0;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 5px;
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 35px 30px;
		${(props) => (props.showInTabletAndMobile ? "" : "display: none;")}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
	}
`;

export const VideoContainer = styled.div`
	margin-top: 36px;
	background: ${COLOR_WHITE};
	width: 700px;
	box-shadow: 0px 9px 30px #d6e8e3;
	@media only screen and (max-width: ${TABLET_BP}px) {
		width: 100%;
	}
`;

export const Heading = styled.h2`
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 28px;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;

	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 26px;
		line-height: 1.08;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 24px;
		line-height: 1.33;
	}
`;

export const VideoTitle = styled.div`
	border-radius: 3px;
	padding: 13px;
	font-size: 16px;
	line-height: 19px;
	text-align: center;
	color: ${COLOR_TEXT_PRIMARY_B2C};

	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 11px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 10px;
		padding: 7px;
	}
`;
